import { AxiosError, AxiosResponse } from "axios";
import { Store } from "vuex";

import { getCart } from "@/apps/merchant3/services/carts.service";
import { ICartWrap } from "@/apps/merchant3/models/IStateCart";
import { IPaymentTerms } from "@/apps/merchant3/models/IStateOffers";
import router from "@/router";
import { store } from "@/shared-store";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { isDirectToCustomerSessionSet } from "@/apps/merchant3/helpers/navigationGuards";
import { getCountryCode } from "@/apps/merchant3/helpers/country";
import cancelCartState from "@/apps/merchant3/hooks/cancelCartState";

export default function useCartPersistState(
  callback: (error?: AxiosError) => boolean,
  forceReload = true
): void {
  const vuexStore = store as unknown as Store<IVuexState>;
  const timeoutErrorCode = 10283;
  const cartNotFoundErrorCode = 10116;
  if (!vuexStore.state.carts.cartTag) {
    if (sessionStorage.getItem("PJ_cartTag")) {
      vuexStore.dispatch(
        "carts/setCartTag",
        sessionStorage.getItem("PJ_cartTag")
      );
    }
    forceReload = true;
  }

  if (forceReload) {
    const cartTag = vuexStore.state.carts.cartTag;
    getCart(cartTag as string).then(
      (response: AxiosResponse<ICartWrap>) => {
        forceReload = false;
        const cart = response.data.cart;
        if (cart) {
          vuexStore.dispatch("carts/setCart", cart);
          sessionStorage.setItem(
            "PJ_userTag",
            response.data.cart.userTag as string
          );

          if (cart.months && cart.cost7 && cart.cost30 && cart.downPayment) {
            const pricing = {
              weeks: (cart.months * 13) / 4,
              months: cart.months,
              weeklyPayment: cart.cost7,
              monthlyPayment: cart.cost30,
              totalAmount: cart.cost30 * cart.months + cart.downPayment,
              creditLineEstimate: cart.creditLineEstimate,
            } as IPaymentTerms;
            vuexStore.dispatch("carts/setPricing", pricing);
            if (cart.activationMethod) {
              vuexStore.dispatch(
                "carts/setActivationMethod",
                cart.activationMethod
              );
            }
          }
        } else {
          // throw error.
        }
        let uniqueRequestList: string | null =
          sessionStorage.getItem("uniqueRequestList");
        if (uniqueRequestList) {
          uniqueRequestList = JSON.parse(uniqueRequestList);
          vuexStore.dispatch("carts/setUniqueRequests", uniqueRequestList);
        }
        callback();
      },

      (error: AxiosError) => {
        if (
          [timeoutErrorCode, cartNotFoundErrorCode].includes(
            error?.response?.data.errorCode
          )
        ) {
          vuexStore.state.person.userData.termsAndConditionsAccept = null;
          vuexStore.state.person.userData.privacyPolicyAccept = null;
          vuexStore.state.person.userData.frontImageURL = null;
          vuexStore.state.person.userData.backImageURL = null;
          vuexStore.state.person.userData.selfieImageURL = null;
          vuexStore.dispatch("customer/resetCustomer");
          vuexStore.dispatch("carts/resetCart");
          vuexStore.dispatch("offers/resetOffers");
          sessionStorage.removeItem("uniqueRequestList");
          cancelCartState();
          if (isDirectToCustomerSessionSet()) {
            router.push({
              name: RouteName.DirectToCustomerWelcome,
              params: {
                countryCode: getCountryCode(),
              },
            });
          } else {
            router.push({ name: RouteName.M3Welcome, params: { countryCode: getCountryCode() } });
          }
        }
      }
    );
  } else {
    callback();
  }
}
